<template>
  <el-container v-model="activePoint" v-loading="pointLoading" class="point-detail-tab">
    <el-col :span="24">
      <el-tabs v-model="activePointTab">
        <el-tab-pane :label="$t('point.configuration')" name="configuration">
          <Point v-if="checkPermission('readPoint') && point" :point="point" @updated="getPoint(pointId)" />
        </el-tab-pane>
        <el-tab-pane :label="$t('point.trend')" name="trend">
          <FormTrend v-if="point" :point="point._id" :alarms="alarms" />
        </el-tab-pane>
        <el-tab-pane :label="$t('point.alarms')" name="alarms">
          <el-tabs v-model="activeAlarm">
            <el-tab-pane :label="$t('point.metricAlarms')" name="metricAlarms">
              <el-button v-if="checkPermission('createAlarm')" @click="showCreateAlarm = true">{{ $t("common.create") }}
              </el-button>
              <el-row class="alarmtableFlex">
                <el-col :span="24">
                  <el-table v-loading="alarmsLoading" :data="alarms" :fit="true" class="border">
                    <el-table-column prop="name" :label="$t('alarms.name')" />
                    <el-table-column prop="telemetry" :label="$t('alarms.telemetry')">
                      <template slot-scope="scope">
                        <span style="font-size: 12px">
                          {{ telemetryDisplayName(scope.row) }}
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column width="160px" :label="$t('admin.actions')" id="action">
                      <template slot-scope="scope">
                        <el-button v-if="checkPermission('updateAlarm')" size="small"
                          @click="editAlarmHandler(scope.row._id)">{{ $t("admin.edit") }}</el-button>
                        <el-button v-if="checkPermission('deleteAlarm')" size="small" type="danger"
                          @click="deleteAlarmHandler(scope.row._id)">{{ $t("admin.delete") }}</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane :label="$t('point.envelopeAlarms')" name="envelopeAlarms">
              <FrequencyPeakAnalyzeAlarmInput :pointId="pointId" />
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane :label="$t('point.conditionControl')" name="conditionControl">
          <AlarmTransactions v-if="checkPermission('readAlarm')" :pointId="point._id" />
        </el-tab-pane>
        <el-tab-pane name="vibrationAnalyzeReports">
          <span slot="label">
            <el-badge :value="activePointUnansweredEvaluationsCount"
              :hidden="activePointUnansweredEvaluationsCount == 0" class="item" type="primary" style="padding: 10px">
              {{ $t("point.detection_reports") }}
            </el-badge>
          </span>

          <VibrationAnalyzeReport :pointId="point._id" />
        </el-tab-pane>
        <el-tab-pane name="maintenance" :label="$t('point.maintenance')">
          <Maintenance :pointId="point._id" />
        </el-tab-pane>
      </el-tabs>
    </el-col>
    <el-dialog width="70% !important" :title="$t('alarms.createalarms')" ref="ruleForm" :visible.sync="showCreateAlarm">
      <CreateAlarm :pointId="pointId" @created="alarmCreated()" />
    </el-dialog>
    <el-dialog width="70% !important" :title="$t('alarms.editalarms')" ref="ruleForm" :visible.sync="showEditAlarm">
      <EditAlarm v-if="showEditAlarm" :pointId="pointId" :alarmId="editAlarmId" @edited="alarmEdited" />
    </el-dialog>
  </el-container>
  <!-- Create form start -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import Point from "./Point";
import FormTrend from "./Form_Trend";
import CreateAlarm from "./CreateAlarm";
import EditAlarm from "./EditAlarm";
import AlarmTransactions from "./AlarmTransactions";
import VibrationAnalyzeReport from "./VibrationAnalyzeReports";
import FrequencyPeakAnalyzeAlarmInput from "./FrequencyPeakAnalyzeAlarmInput.vue";
import Maintenance from "./Maintenance.vue";

export default {
  name: "Tab_Point_Detail",
  components: {
    Point,
    FormTrend,
    CreateAlarm,
    EditAlarm,
    AlarmTransactions,
    VibrationAnalyzeReport,
    FrequencyPeakAnalyzeAlarmInput,
    Maintenance
  },
  props: {
    pointId: String,
  },
  data() {
    return {
      activePointTab: "trend",
      activeAlarm: "metricAlarms",
      alarm: "",
      showCreateAlarm: false,
      showEditAlarm: false,
      editAlarm: "",
      activePoint: "",
      activeNames: ["detail"],
    };
  },
  mounted() { },
  async created() {
    await this.getDeviceConfigurations();
    if (this.checkPermission("readAlarm")) {
      await this.getAlarms(this.pointId);
    }
  },
  computed: {
    activePointUnansweredEvaluationsCount() {
      let p = this.flatTree.find((x) => x._id == this.activeTab);
      return p ? p.unansweredEvaluationsCount : 0;
    },
    point() {
      let index = this.points.findIndex((x) => x._id == this.pointId);
      let p =  this.points[index];
      console.log("aaa",p)
      return p;
    },
    ...mapState("admin", ["telemetry"]),
    ...mapState("tree", ["activeTags", "flatTree"]),
    ...mapState("point", ["points", "pointLoading"]),
    ...mapState("account", ["activeTab"]),
    ...mapState("alarm", ["alarms", "alarmsLoading"]),
  },
  methods: {
    editAlarmHandler(alarmId) {
      this.editAlarmId = alarmId;
      this.showEditAlarm = true;
    },
    alarmCreated() {
      this.showCreateAlarm = false;
    },
    alarmEdited() {
      this.showEditAlarm = false;
    },
    deleteAlarmHandler(id) {
      this.$confirm(this.$t("admin.warningtext"), this.$t("admin.warning"), {
        confirmButtonText: this.$t("admin.warningConfirmText"),
        cancelButtonText: this.$t("admin.warningCancelText"),
        type: "warning",
      })
        .then(() => {
          this.deleteAlarm({ pointId: this.pointId, alarmId: id });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("admin.warningDeleteCancel"),
          });
        });
    },
    telemetryDisplayName(v) {
      let telemetryName = v.telemetry;

      let telemetry = this.telemetry.data
        .filter((x) => x.hidden == false)
        .find((x) => v == x.name);
      if (telemetry && telemetry.displayName) {
        telemetryName = telemetry.displayName;
      }
      telemetryName = this.$t(`duck.${telemetryName}`) + ` (${this.$t("duck."+v.source.trim())})`;
      return telemetryName;
    },
    ...mapActions("tree", ["updateConfig"]),
    ...mapActions("tree", ["updateConfig"]),
    ...mapActions("alarm", ["getAlarms", "deleteAlarm"]),
    ...mapActions("point", ["getPoint"]),
    ...mapActions("deviceConfigurations", ["getDeviceConfigurations"]),
  },
};
</script>

<style scoped>
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.alarmtableFlex {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}

.border.el-table .cell {
  word-break: break-word !important;
}

.el-collapse {
  padding: 5px;
}

.refreshButton {
  position: absolute;
  padding: 5px;
  margin: 10px;
  right: 45px;
  z-index: 1;
}

.device-tab {
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow: auto;
  min-height: 200px;
}
</style>